export var AvailableLanguages;
(function (AvailableLanguages) {
    AvailableLanguages["IT"] = "it";
    AvailableLanguages["EN"] = "en";
    AvailableLanguages["US"] = "us";
})(AvailableLanguages || (AvailableLanguages = {}));
